import axios from "axios";

export const apiVision360 = axios.create({
  baseURL: import.meta.env.VITE_VISION_360_API,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
